/**
 * Centralized Modal exports with automatic z-index management
 *
 * ALWAYS import Modal from here, NOT from 'react-bootstrap' directly
 * This ensures proper z-index handling for nested modals
 */

import { Modal as BootstrapModal } from 'react-bootstrap'
import { ReactBootstrapModalWrapper } from './ReactBootstrapModalWrapper'

// Export our wrapped Modal that handles z-index automatically
// Also attach the static sub-components (Header, Body, Title, Footer) from react-bootstrap
export const Modal = Object.assign(ReactBootstrapModalWrapper, {
  Header: BootstrapModal.Header,
  Body: BootstrapModal.Body,
  Title: BootstrapModal.Title,
  Footer: BootstrapModal.Footer,
  Dialog: BootstrapModal.Dialog,
})

// Re-export types
export type { ModalProps } from 'react-bootstrap'

// Export Radix-based Modal system (for complex modals)
export {
  Dialog,
  DialogPortal,
  DialogOverlay,
  DialogClose,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from './ModalPrimitive'

export type { DialogContentSize } from './ModalPrimitive'

// Export our custom Modal component (Radix-based)
export { Modal as FbModal } from './Modal'
export type { IModalProps } from './Modal'
